import { BannerMedia } from '@payload-types';

type SizeKey = keyof NonNullable<BannerMedia['sizes']>;

const getCustomUrl = (
  sizeName: string,
  customSizes: NonNullable<BannerMedia['customSizes']>
) => {
  const custom = customSizes.find((item) => item.sizeName === sizeName);
  if (custom && typeof custom.image !== 'number') {
    return custom.image.url;
  }
  return null;
};

export const getCustomUrls = (
  desktopFieldName: string,
  mobileFieldName: string,
  customSizes?: BannerMedia['customSizes']
) => {
  return {
    desktopCustomUrl: customSizes ? getCustomUrl(desktopFieldName, customSizes) : null,
    mobileCustomUrl: customSizes ? getCustomUrl(mobileFieldName, customSizes) : null
  };
};

export const getSize = (
  sizes: BannerMedia['sizes'],
  key: SizeKey,
  customUrl: string | null | undefined
) => {
  const size = sizes?.[key];
  return size ? { ...size, url: customUrl || size.url } : undefined;
};
